import { Injectable } from '@angular/core';
import * as UrlService from '../../shared/services/url.service';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { QueryOptions } from '../../shared/services/url.service';
import { sharedConstants } from '../../shared/shared-constants';
import { FileResponse } from '../models/FileUploadResponse';
import { Observable } from 'rxjs';
import { ApiResponse } from '../models/ApiResponse';

@Injectable({ providedIn: 'root' })
export class FileUploadService {
  private controllerName: string;

  constructor(
    private apiClient: UrlService.UrlService,
    private httpClient: HttpClient
  ) {
    this.controllerName = "File";
  }

  public upload(formData): Observable<HttpEvent<FileResponse>> {
    const options = new QueryOptions();
    options.reportProgress = true;
    return this.apiClient.postFile<FileResponse>(sharedConstants.appName, this.controllerName, 'FileUpload', formData, options);
  }

  public deleteFile(filedata: FileResponse): Observable<ApiResponse<boolean>> {
    return this.apiClient.post<ApiResponse<boolean>>(sharedConstants.appName, this.controllerName, "DeleteFile", filedata, null);
  }

  public debugFunc(): Observable<string> {
    return this.apiClient.post<string>(sharedConstants.appName, this.controllerName, "DebugFunc", null, null);
  }
}
